var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"emd-badge",class:_vm.status != '' ? `_color_${_vm.status}` : ''},[(_vm.icon)?[_c('i',{class:['uil', `uil-${_vm.icon}`, 'eu-mr_1']})]:_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }